import React, { useState, useEffect } from "react";

import axios from "@app/lib/axios";

import * as Constant from "@app/Constant.js";
import * as util from "@app/lib/utility";

const DeployAppList = ({ selectedAppList }) => {
    return (
        <>
            {selectedAppList &&
                selectedAppList.map((app) => {
                    return <AppListDraw app={app} key={app.name} />;
                })}
        </>
    );
};

const AppListDraw = ({ app }) => {
    return app ? (
        <div className="col-sm-2">
            <div className="card">
                <div className="card-header" value={app.name}>
                    {app.name}
                </div>
                <div className="card-body">
                    <a href={app.deploy_url}>
                        <img width="150" height="150" className="mx-auto d-block" alt="Image" src={app.thumb_url} />
                    </a>
                </div>
            </div>
        </div>
    ) : (
        <></>
    );
};

const DeployPlatformList = ({ platformList, selectedPlatform, onSelectPlatform }) => {
    return (
        <>
            {platformList &&
                platformList.map((platform) => {
                    return <PlatformListDraw platform={platform} selectedPlatform={selectedPlatform} onSelectPlatform={onSelectPlatform} key={platform.name} />;
                })}
        </>
    );
};

const PlatformListDraw = ({ platform, selectedPlatform, onSelectPlatform }) => {
    return platform ? (
        <label className="custom-control custom-radio custom-control-inline">
            <input type="radio" name="status" value={platform.name} checked={selectedPlatform == platform.name} className="custom-control-input" onChange={onSelectPlatform} />
            <span className="custom-control-label">
                <span className={"icon-circle p-1 pl-2 pr-2 text-" + platform.color + " bg-" + platform.color + "-light"}>
                    <i className={"fab " + platform.icon}></i>
                </span>
            </span>
        </label>
    ) : (
        <></>
    );
};
const HQQADeploy = (props) => {
    const [appData, setAppData] = useState(null);
    const [selectedPlatform, setSelectedPlatform] = useState(false);
    const [platformList, setPlatformList] = useState(null);
    const [selectedAppList, setSelectedAppList] = useState(false);
    useEffect(() => {
        axios({
            method: "get",
            url: Constant.API_DOMAIN + "/api/_dev_util/hq/qa/deploy",
        }).then((res) => {
            const appData = res.data.qaUrl;
            appData.forEach((app) => {
                app.platform = res.data.qaPlatformList.filter((platform) => {
                    return app.id == platform.app_id;
                });
            });
            setAppData(res.data.qaUrl);
            setSelectedAppList(appData);
            setPlatformList(res.data.platform);
        });

        return () => {};
    }, [props]);

    useEffect(() => {
        const selectedList = selectedPlatform
            ? appData.filter((app) => {
                  const platform = app.platform.find((platform) => platform.name == selectedPlatform);
                  return platform;
              })
            : appData;
        setSelectedAppList(selectedList);
        return () => {};
    }, [selectedPlatform]);

    const onSelectPlatform = (e) => {
        const { name, value, checked } = e.target;
        setSelectedPlatform(value);
    };

    return (
        <div className="dashboard-wrapper no-admin-menu">
            <div className="dashboard-ecommerce">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        <div className="col">
                            <div className="page-header">
                                <h2 className="pageheader-title">QA 배포앱 다운로드</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid dashboard-content">
                <div className="row mb-3">
                    <div className="col">
                        <div className="input-group input-group-sm mb-3">
                            <label className="custom-control custom-radio custom-control-inline">
                                <input type="radio" name="status" value="" checked={!selectedPlatform} className="custom-control-input" onChange={onSelectPlatform} />
                                <span className="custom-control-label">플랫폼 전체</span>
                            </label>
                            <DeployPlatformList platformList={platformList} selectedPlatform={selectedPlatform} onSelectPlatform={onSelectPlatform} />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <DeployAppList selectedAppList={selectedAppList} />
                </div>
            </div>
        </div>
    );
};

export { HQQADeploy as default };
